import parse from 'node-html-parser';
import ReactHtmlParser from "react-html-parser";
import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,} from "@mui/material";

const parseStyle = (styleString: string) => {
    return styleString.split(';').reduce((acc, rule) => {
        const [property, value] = rule.split(':').map(item => item.trim());
        if (property && value) {
            acc[property.replace(/-./g, match => match[1].toUpperCase())] = value;
        }
        return acc;
    }, {} as Record<string, string>);
};


const parseTableContent = (htmlContent: string) => {
    const root = parse(htmlContent);
    const table = root.querySelector('table');
    if (!table) return null;

    const headers = table.querySelectorAll('thead tr').map((tr: any) =>
        tr.querySelectorAll('th').map((td: any) => ({
            content: td.innerHTML,
            rowSpan: parseInt(td.getAttribute('rowspan') || '1'),
            colSpan: parseInt(td.getAttribute('colspan') || '1')
        }))
    );

    const rows = table.querySelectorAll('tbody tr').map((tr: any) =>
        tr.querySelectorAll('td,th').map((td: any) => ({
            component: td.tagName.toLowerCase(),
            content: td.innerHTML,
            rowSpan: parseInt(td.getAttribute('rowspan') || '1'),
            colSpan: parseInt(td.getAttribute('colspan') || '1'),
            style: td.getAttribute('style'),
        }))
    );

    return {headers, rows};
};

const TableContent = ({content}: { content: string }) => {
    const tableData = parseTableContent(content);
    if (!tableData) return null;

    return (
        <TableContainer component={Box}>
            <Table>
                <TableHead>
                    {tableData.headers.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {row.map((cell: any, cellIndex: number) => (
                                <TableCell
                                    key={cellIndex}
                                    rowSpan={cell.rowSpan}
                                    colSpan={cell.colSpan}
                                    sx={{verticalAlign: 'bottom'}}
                                >
                                    {ReactHtmlParser(cell.content)}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableHead>
                <TableBody>
                    {tableData.rows.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {row.map((cell: any, cellIndex: number) => (
                                    <TableCell
                                        component={cell.component}
                                        key={cellIndex}
                                        rowSpan={cell.rowSpan}
                                        colSpan={cell.colSpan}
                                        style={{
                                            verticalAlign: 'bottom',
                                            ...parseStyle(cell.style || '')
                                        }}
                                    >
                                        {ReactHtmlParser(cell.content)}
                                    </TableCell>
                                )
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TableContent;